import type { ReferenceImageItem } from '../api/referenceImages'
import { normalizeLibraryUiFolderPath } from './libraryPaths'

/** 同标签页内从其它路由返回图库时，缓存有效期内跳过全量重载 */
export const LIBRARY_ROUTE_RETURN_STALE_MS = 5 * 60 * 1000

export type LibraryPageSessionCache = {
  folderPath: string
  items: ReferenceImageItem[]
  folderPaths: string[]
  total: number
  page: number
  loadedAt: number
  scrollTop: number
  selectedPublicId: string | null
}

let sessionCache: LibraryPageSessionCache | null = null

export function getLibraryPageSessionCache(): LibraryPageSessionCache | null {
  return sessionCache
}

export function setLibraryPageSessionCache(next: LibraryPageSessionCache | null): void {
  sessionCache = next
}

export function isLibrarySessionCacheFresh(
  cache: LibraryPageSessionCache,
  folderPath: string,
  staleMs = LIBRARY_ROUTE_RETURN_STALE_MS,
): boolean {
  if (cache.items.length === 0) return false
  if (Date.now() - cache.loadedAt > staleMs) return false
  return normalizeLibraryUiFolderPath(cache.folderPath) === normalizeLibraryUiFolderPath(folderPath)
}
